// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import $ from "../jquery_global";
import "@hotwired/turbo-rails";
import "../remote_js";
require("@rails/activestorage").start();
require("../channels");
require("trix");
require("@rails/actiontext");

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "../controllers";
import "../pages/batch.js";
import "../pages/trace_template.js";
import "../pages/admin_quotations.js";
import "../pages/admin_batch.js";
import "../pages/admin_restaurants.js";
import "../pages/admin_trace_products_select.js";
import "../pages/admin_distributors.js";
import "../pages/supplier_delivery.js";
import "../pages/admin_map_products.js";
import "../pages/admin_supplier_client_name_mappings.js";
import "../pages/admin_smart_search.js";

document.addEventListener("turbo:before-cache", function () {
  try {
    $('[data-toggle="tooltip"]').tooltip("hide");
  } catch (_) {}
  try {
    $(".modal").modal("hide");
  } catch (_) {}
  $(".modal-backdrop").remove();
  $("body").removeClass("modal-open").css("padding-right", "");

  $(".select2-hidden-accessible").each(function () {
    try {
      $(this).select2("destroy");
    } catch (_) {}
  });
  document.querySelectorAll(".selectized").forEach((el) => {
    try {
      el.selectize?.destroy();
    } catch (_) {}
  });
  document.querySelectorAll(".flatpickr-input").forEach((el) => {
    try {
      el._flatpickr?.destroy();
    } catch (_) {}
  });
  document.querySelectorAll(".dropzone").forEach((el) => {
    try {
      el.dropzone?.destroy();
    } catch (_) {}
  });
});
